import { types as t } from 'mobx-state-tree';

import { careerSitelanguages } from '@locale/locale-store';

export const Language = t.enumeration('Language', careerSitelanguages);

export const Translation = t.model('Translation', {
  title: t.string,
  language: t.string,
});
